import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const AboutUsPage = () => {
  return <SanityContentPage slug='about-us' />
}

export default AboutUsPage
